// extracted by mini-css-extract-plugin
module.exports = {"UpdateNote":"UpdateNote_UpdateNote__YNdBR","Card":"UpdateNote_Card___7BPT","Content":"UpdateNote_Content__9y0K9"};